<template>
    <div class="row justify-content-center">
        <div class="col-12 d-flex justify-content-center">
            <div 
                class="card border-light" 
                style="width: 18rem;"
            >
                <div class="card-body text-center">
                    <b-spinner 
                        variant="primary" 
                        type="grow"
                        label="Loading" 
                        font-scale="10.5"
                    />
                    <h5 class="card-title">{{ $t("redirecting") }}</h5>
                    <p class="card-text">
                        {{ $t("redirecting") }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
mounted() {
    const token = this.$UserSession.getValue.call(this, "authToken");

    if (token) {
        this.$cfetch(`${this.$settings.APIBaseURL}/forms/downloadredirect`, {
            data: {
                formresponse_id: this.$route.params.formresponse_id,
                asset_id: this.$route.params.asset_id
            }
        })
        .then((res) => {
            if (res.status === 'SUCCESS') {
                window.location.href = `${this.$settings.APIBaseURL}${res.url}`;
            }
        })
        .catch((error) => {
            this.$log.error.call(this, error);
            console.log(error)
        });
    } else {
        this.$store.commit('logOut');
    }
},

};
</script>
